import * as React from "react";
import type { SVGProps } from "react";
const PenThickIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" d="M18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0" /></svg>;
export default PenThickIcon;